import { useNavigate } from 'react-router-dom'
import { Pagination, Stack } from '@mui/material'
import { useAtomValue, useSetAtom } from 'jotai'
import { condParamAtom, searchTriggerAtom } from 'store/commonAtoms'
import { useSearchUrl } from 'hooks/search'


const PaginationList = ({ data, gap=0, max=50, siblingCount=0, total }) => {
    const setTrigger = useSetAtom(searchTriggerAtom)
    const { path, page } = useSearchUrl()
    const navi = useNavigate()
    const params = useAtomValue(condParamAtom)

    const handleChange = (_, p) => {
        if (total) setTrigger(true)
        navi(`${path}/${p}${params}`)
    }

    const startIndex = (page - 1) * max

    return (
        <Stack
            alignItems="center"
        >
            {data && (<>
            <Stack
                width="100%"
                gap={gap}
            >
                {total ? data : data.slice(startIndex, startIndex + max)}
            </Stack>
            <Pagination
                count={Math.ceil((total || data.length) / max)}
                variant="outlined"
                shape="rounded"
                page={page}
                siblingCount={siblingCount}
                onChange={handleChange}
                sx={{ pt : 3 }}
            />
            </>)}
        </Stack>
    )
}

export default PaginationList
